module.exports = __webpack_public_path__ + "img/back-feu.83973431.jpg";